module.exports = __webpack_public_path__ + "static/img/phone.8fadd4d6.png";